/* No external services, analytics, duplicate cart, or simulated transactions. */
(()=>{'use strict';
if(window.__enormityInitialized)return;window.__enormityInitialized=true;
const root=document.documentElement;root.classList.add('en-js');
const reduce=matchMedia('(prefers-reduced-motion: reduce)'),fine=matchMedia('(hover: hover) and (pointer: fine)');
let paused=reduce.matches||document.body.dataset.motionEnabled==='false';
const observers=new Set(),all=(q,c=document)=>Array.from(c.querySelectorAll(q));
function motion(){root.classList.toggle('en-motion-paused',paused);all('[data-motion-toggle]').forEach(b=>{b.setAttribute('aria-pressed',String(paused));b.setAttribute('aria-label','Pozastavit animace');b.title=paused?'Spustit animace':'Pozastavit animace';});all('[data-en-video]').forEach(v=>{if(paused)v.pause();else playVideo(v.closest('[data-video-hero]'));});}
reduce.addEventListener('change',()=>{if(reduce.matches)paused=true;motion();});
function openDialog(d,t){if(!d||typeof d.showModal!=='function')return;d.__trigger=t;d.showModal();document.body.classList.add('en-modal-open');d.querySelector('[data-dialog-close]')?.focus({preventScroll:true});}
document.addEventListener('click',e=>{const b=e.target.closest('[data-motion-toggle]');if(b){paused=!paused;motion();}
const t=e.target.closest('[data-dialog-open]');if(t){e.preventDefault();openDialog(document.getElementById(t.dataset.dialogOpen),t);}
const close=e.target.closest('[data-dialog-close]');if(close)close.closest('dialog')?.close();
const z=e.target.closest('[data-en-zoom]');if(z){const im=z.closest('[data-en-gallery]')?.querySelector('[data-main-image]'),d=document.getElementById('EnormityLightbox');if(im&&d){const big=d.querySelector('img');big.src=im.currentSrc||im.src;big.alt=im.alt;d.querySelector('[data-lightbox-caption]').textContent=im.alt;openDialog(d,z);}}
const link=e.target.closest('.en-mobile-menu a');if(link)link.closest('details').open=false;});
function dialog(d){if(d.dataset.enBound)return;d.dataset.enBound='true';d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();});d.addEventListener('close',()=>{if(!document.querySelector('dialog[open]'))document.body.classList.remove('en-modal-open');if(d.__trigger?.isConnected)d.__trigger.focus({preventScroll:true});});}
function gallery(g){if(g.dataset.enBound)return;g.dataset.enBound='true';const im=g.querySelector('[data-main-image]'),reflection=g.querySelector('[data-reflection]'),buttons=all('[data-view-src]',g);if(!im)return;let req=0;
buttons.forEach(b=>b.addEventListener('click',()=>{const seq=++req,next=new Image();next.onload=()=>{if(seq!==req||!im.isConnected)return;im.classList.add('en-is-switching');setTimeout(()=>{if(seq!==req||!im.isConnected)return;im.removeAttribute('srcset');im.removeAttribute('sizes');im.src=next.src;im.alt=b.dataset.viewAlt||'';if(reflection){reflection.removeAttribute('srcset');reflection.src=next.src;}buttons.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const s=g.querySelector('[data-gallery-status]');if(s)s.textContent=b.dataset.viewAlt||'';requestAnimationFrame(()=>requestAnimationFrame(()=>im.classList.remove('en-is-switching')));},120);};next.onerror=()=>{const s=g.querySelector('[data-gallery-status]');if(s)s.textContent='Pohled se nepoda\u0159ilo na\u010d\u00edst. Zkuste to znovu.';};next.src=b.dataset.viewSrc;}));
const stage=g.querySelector('.en-stage');if(stage){let raf=0;stage.addEventListener('pointermove',e=>{if(paused||reduce.matches||!fine.matches||raf)return;const r=stage.getBoundingClientRect(),x=((e.clientX-r.left)/r.width-.5)*5,y=((e.clientY-r.top)/r.height-.5)*-3;raf=requestAnimationFrame(()=>{stage.style.setProperty('--en-ry',x.toFixed(2)+'deg');stage.style.setProperty('--en-rx',y.toFixed(2)+'deg');raf=0;});});stage.addEventListener('pointerleave',()=>{stage.style.setProperty('--en-ry','0deg');stage.style.setProperty('--en-rx','0deg');});}}
function playVideo(hero){if(!hero||paused||reduce.matches)return;const mobile=matchMedia('(max-width:760px)').matches,videos=all('[data-en-video]',hero),chosen=videos.find(v=>v.dataset.videoSize===(mobile?'mobile':'desktop'))||videos[0];videos.forEach(v=>{v.hidden=v!==chosen;if(v!==chosen)v.pause();});if(!chosen)return;chosen.muted=true;chosen.autoplay=true;chosen.playsInline=true;if(hero.classList.contains('en-hero--auto-video'))hero.classList.add('en-video-ready');const p=chosen.play();if(p&&typeof p.catch==='function')p.catch(()=>{});}
function hero(h){if(h.dataset.videoBound)return;h.dataset.videoBound='true';all('[data-en-video]',h).forEach(v=>{v.addEventListener('loadeddata',()=>h.classList.add('en-video-ready'),{once:true});v.addEventListener('playing',()=>h.classList.add('en-video-ready'));v.addEventListener('error',()=>{h.classList.remove('en-video-ready');h.classList.remove('en-hero--auto-video');});});if(h.classList.contains('en-hero--auto-video'))h.classList.add('en-video-ready');playVideo(h);}
let resizeTimer;window.addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>all('[data-video-hero]').forEach(playVideo),200);},{passive:true});document.addEventListener('visibilitychange',()=>{if(document.hidden)all('[data-en-video]').forEach(v=>v.pause());else all('[data-video-hero]').forEach(playVideo);});
/* ENORMITY_HERO_AFTER_GATE_V1 */
document.addEventListener('enormity:presale-accepted',()=>{
  all('[data-video-hero]:not(.en-hero--legacy-chapter)').forEach(h=>{
    const mobile=matchMedia('(max-width:760px)').matches;
    const videos=all('[data-en-video]',h);
    const chosen=videos.find(v=>v.dataset.videoSize===(mobile?'mobile':'desktop'))||videos[0];
    if(chosen){
      try{chosen.currentTime=0}catch(e){}
      chosen.hidden=false;
    }
    const reflection=h.querySelector('[data-en-reflection-video]');
    if(reflection){
      try{reflection.pause();reflection.currentTime=0}catch(e){}
    }
    h.classList.add('en-video-ready');
    requestAnimationFrame(()=>playVideo(h));
  });
});
function product(f){if(f.dataset.enBound)return;f.dataset.enBound='true';const select=f.querySelector('select[name="id"]');if(!select)return;select.addEventListener('change',()=>{const o=select.selectedOptions[0],b=f.querySelector('[data-product-submit]'),p=f.closest('[data-product-page]')?.querySelector('[data-product-price]'),ok=o?.dataset.available==='true';if(b){b.disabled=!ok;b.textContent=ok?'P\u0159idat do ko\u0161\u00edku':'Nedostupn\u00e9';}if(p&&o)p.textContent=o.dataset.price||'';});f.addEventListener('submit',()=>{const b=f.querySelector('[data-product-submit]');if(b){b.setAttribute('aria-busy','true');setTimeout(()=>b.disabled=true,0);}});}
function init(c=document){all('[data-en-gallery]',c).forEach(gallery);all('dialog:not([data-en-presale-modal])',c).forEach(dialog);all('[data-video-hero]',c).forEach(hero);all('[data-product-form]',c).forEach(product);const items=all('.en-scroll-reveal',c);if('IntersectionObserver'in window&&!paused&&!reduce.matches){const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('en-visible');io.unobserve(e.target);}}),{threshold:.08});observers.add(io);items.forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('en-will-reveal');io.observe(el);}else el.classList.add('en-visible');});}motion();}
document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>{observers.forEach(io=>all('.en-scroll-reveal',e.target).forEach(el=>io.unobserve(el)));const d=e.target.querySelector('dialog[open]');if(d)d.close();});document.addEventListener('keydown',e=>{if(e.key==='Escape')all('.en-mobile-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});init();})();


/* ENORMITY_AUTOVIDEO_SYNC_V1 */
(()=>{'use strict';
function bindReflection(scope=document){
  scope.querySelectorAll('[data-video-hero]').forEach(hero=>{
    const main=hero.querySelector('[data-en-fallback-video]');
    const reflection=hero.querySelector('[data-en-reflection-video]');
    if(!main||!reflection||reflection.dataset.enSyncBound==='true')return;
    reflection.dataset.enSyncBound='true';
    reflection.muted=true;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const sync=()=>{
      if(!Number.isFinite(main.currentTime))return;
      if(Math.abs((reflection.currentTime||0)-main.currentTime)>.12){
        try{reflection.currentTime=main.currentTime}catch(e){}
      }
    };
    const start=()=>{
      if(reduced.matches||document.documentElement.classList.contains('en-motion-paused')){
        reflection.pause();
        return;
      }
      sync();
      const p=reflection.play();
      if(p&&typeof p.catch==='function')p.catch(()=>{});
    };
    main.addEventListener('playing',start);
    main.addEventListener('pause',()=>reflection.pause());
    main.addEventListener('seeking',sync);
    main.addEventListener('timeupdate',sync);
    document.addEventListener('visibilitychange',()=>{
      if(document.hidden)reflection.pause();
      else if(!main.paused)start();
    });
    const observer=new MutationObserver(()=>{
      if(document.documentElement.classList.contains('en-motion-paused'))reflection.pause();
      else if(!main.paused)start();
    });
    observer.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
    if(!main.paused)start();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>bindReflection());
else bindReflection();
document.addEventListener('shopify:section:load',e=>bindReflection(e.target));
})();


/* ENORMITY_LAUNCH_COUNTDOWN_V1 */
(()=>{'use strict';
function initLaunchCountdown(scope=document){
  scope.querySelectorAll('[data-en-launch-countdown]').forEach(bar=>{
    if(bar.dataset.enCountdownBound==='true')return;
    bar.dataset.enCountdownBound='true';
    const target=new Date(bar.dataset.target).getTime();
    const days=bar.querySelector('[data-countdown-days]');
    const hours=bar.querySelector('[data-countdown-hours]');
    const minutes=bar.querySelector('[data-countdown-minutes]');
    const seconds=bar.querySelector('[data-countdown-seconds]');
    const pad=n=>String(Math.max(0,n)).padStart(2,'0');
    const tick=()=>{
      const left=target-Date.now();
      if(left<=0){
        bar.classList.add('en-launchbar--launched');
        if(days)days.textContent='00';
        if(hours)hours.textContent='00';
        if(minutes)minutes.textContent='00';
        if(seconds)seconds.textContent='00';
        return false;
      }
      const total=Math.floor(left/1000);
      const d=Math.floor(total/86400);
      const h=Math.floor((total%86400)/3600);
      const m=Math.floor((total%3600)/60);
      const s=total%60;
      if(days)days.textContent=String(d);
      if(hours)hours.textContent=pad(h);
      if(minutes)minutes.textContent=pad(m);
      if(seconds)seconds.textContent=pad(s);
      return true;
    };
    tick();
    const timer=setInterval(()=>{if(!tick())clearInterval(timer);},1000);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initLaunchCountdown());
else initLaunchCountdown();
document.addEventListener('shopify:section:load',e=>initLaunchCountdown(e.target));
})();


/* ENORMITY_PRESALE_MODAL_ANALYTICS_V1 */
(()=>{'use strict';
const VERSION='drop001-2026-12-15-v1';
const SESSION_KEY='enormity_presale_ack_'+VERSION;

function publishEvent(name,data={}){
  const payload={
    version:VERSION,
    ship_date:'2026-12-15',
    page_path:location.pathname,
    page_title:document.title,
    ...data
  };
  try{
    if(window.Shopify?.analytics?.publish){
      const p=window.Shopify.analytics.publish('enormity:'+name,payload);
      if(p&&typeof p.catch==='function')p.catch(()=>{});
    }
  }catch(e){}
  try{
    if(Array.isArray(window.dataLayer)){
      window.dataLayer.push({event:'enormity_'+name,...payload});
    }
  }catch(e){}
  try{
    if(typeof window.gtag==='function'){
      window.gtag('event','enormity_'+name,payload);
    }
  }catch(e){}
}

function storageGet(){
  try{return sessionStorage.getItem(SESSION_KEY)==='1'}catch(e){return false}
}
function storageSet(){
  try{sessionStorage.setItem(SESSION_KEY,'1')}catch(e){}
}

function initPresaleModal(){
  const dialog=document.querySelector('[data-en-presale-modal]');
  if(!dialog||dialog.dataset.enPresaleBound==='true')return;
  dialog.dataset.enPresaleBound='true';
  let accepted=false;
  const accept=dialog.querySelector('[data-en-presale-accept]');
  const force=new URLSearchParams(location.search).get('presale_popup')==='1';
  const shouldOpen=force||!storageGet();

  dialog.addEventListener('cancel',e=>e.preventDefault());
  dialog.addEventListener('click',e=>{if(e.target===dialog)e.preventDefault();});
  /* Chromium close-watcher může dialog zavřít druhým Esc bez 'cancel' – bez potvrzení ho vrátíme zpět. */
  dialog.addEventListener('close',()=>{
    if(accepted)return;
    requestAnimationFrame(()=>{if(!accepted&&!dialog.open&&dialog.isConnected){dialog.showModal();accept?.focus({preventScroll:true});}});
  });

  if(accept){
    accept.addEventListener('click',()=>{
      accepted=true;
      publishEvent('presale_understood',{interaction:'button_click',button_label:(accept.textContent||'').trim()});
      storageSet();
      document.documentElement.classList.remove('en-presale-gated');
      if(dialog.open)dialog.close();
      setTimeout(()=>document.dispatchEvent(new CustomEvent('enormity:presale-accepted')),40);
    });
  }

  if(shouldOpen&&typeof dialog.showModal==='function'){
    const open=()=>{
      if(dialog.open)return;
      document.documentElement.classList.add('en-presale-gated');
      dialog.showModal();
      requestAnimationFrame(()=>accept?.focus({preventScroll:true}));
      publishEvent('presale_notice_viewed',{forced_preview:force});
    };
    /* Na homepage nejdřív doběhne ~1s intro (en-campaign.js), pak popup. */
    if(document.documentElement.classList.contains('en-intro-play')){
      let done=false;const go=()=>{if(done)return;done=true;open();};
      document.addEventListener('enormity:intro-done',go,{once:true});
      setTimeout(go,1600);
    }else open();
  }
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPresaleModal);
else initPresaleModal();
document.addEventListener('shopify:section:load',initPresaleModal);
})();


/* ENORMITY_A11Y_FIXES_V7: výška sticky odpočtu -> --en-launchbar-h (pro scroll-padding kotev). */
(()=>{'use strict';
const bar=document.querySelector('.en-launchbar');if(!bar)return;
const set=()=>document.documentElement.style.setProperty('--en-launchbar-h',Math.ceil(bar.getBoundingClientRect().height)+'px');
set();if('ResizeObserver'in window)new ResizeObserver(set).observe(bar);else addEventListener('resize',set,{passive:true});
})();
